import Vue from '@/externals/vue';
import t from './types';

export default {
  [t.HASH]: (state, hash) => {
    state.hash = hash;
  },
  [t.RESET]: state => {
    state.events = [];
    state.selections = [];
    state.status = t.STARTED;
    state.currentPreset = '';
    state.currentSort = t.SORT_TIME;

    Object.entries(state.fields).forEach(([id, field]) => {
      Vue.set(state.fields, id, {
        ...field,
        metric: field.defaultMetric,
      });
    });

    Object.entries(state.metrics).forEach(([id, metric]) => {
      Vue.set(state.metrics, id, {
        ...metric,
        value: metric.defaultValue,
      });
    });
  },

  [t.QUERY]: (state, query) => {
    state.query = query;
  },

  [t.EVENT_FILTER]: (state, eventId) => {
    state.eventFilter = eventId;
  },

  [t.EVENT_RUNNERS]: (state, eventRunners) => {
    state.eventRunners = eventRunners;
  },

  [t.FIELDS]: (state, filters) => {
    state.fields = {};
    state.categories = [];
    state.metrics = {};
    const groups = new Map();

    filters.categories.forEach(({ name, displayName, order, fields }) => {
      state.categories.push({
        id: name,
        name: displayName,
        order,
      });

      fields.forEach(field => {
        const subFields = field.subFields || [field];
        const hasSubFields = subFields.length > 1;

        subFields.forEach(subField => {
          const groupBy = hasSubFields ? field : subField;
          const groupById = `${groupBy.name}.${groupBy.defaultRange}`;
          if (!groups.has(groupById)) {
            groups.set(groupById, {
              id: groupById,
              name: groupBy.displayName,
            });
          }

          groupBy.metrics.forEach(metric => {
            // check for any 'active' filters which will be present if a hash was used
            let metricValue = metric.defaultValue;
            if (filters.hasOwnProperty('activeFilters') && filters.activeFilters !== null) {
              filters.activeFilters.forEach(activeFilter => {
                if (
                  activeFilter.name === groupBy.name &&
                  activeFilter.range === groupBy.defaultRange &&
                  activeFilter.metric === metric.name
                ) {
                  metricValue = activeFilter.value;
                }
              });
            }

            Vue.set(state.metrics, `${groupBy.name}.${metric.name}.${groupBy.defaultRange}`, {
              id: `${groupBy.name}.${metric.name}.${groupBy.defaultRange}`,
              label: metric.displayName,
              range: groupBy.defaultRange,
              setting: groupBy.name,
              value: metricValue,
              ...metric,
            });
          });
          // rekey metric so it's unique per field
          groupBy.defaultMetric = `${groupBy.name}.${groupBy.defaultMetric}.${groupBy.defaultRange}`;

          Vue.set(state.fields, `${subField.name}.${subField.defaultRange}`, {
            name: subField.name,
            order: subField.order,
            label: subField.displayName,
            category: name,
            group: {
              id: groupById,
              name: groupBy.displayName,
            },
            metrics: groupBy.metrics.map(metric => `${groupBy.name}.${metric.name}.${groupBy.defaultRange}`),
            defaultMetric: groupBy.defaultMetric,
            metric: groupBy.defaultMetric,
            range: groupBy.defaultRange,
            description: groupBy.description || '',
          });
        });
      });
    });

    state.groups = Array.from(groups.values());
  },

  [t.INFO]: (state, info) => {
    state.info = info;
  },

  [t.PRESET]: (state, currentPreset) => {
    state.currentPreset = currentPreset;

    if (currentPreset === '') {
      return;
    }

    state.presets.forEach(preset => {
      if (preset.name === currentPreset) {
        preset.filters.forEach(filter => {
          Vue.set(
            state.fields[`${filter.name}.${filter.range}`],
            'metric',
            `${filter.name}.${filter.metric}.${filter.range}`
          );
          Vue.set(state.metrics[`${filter.name}.${filter.metric}.${filter.range}`], 'value', filter.value);
        });
      }
    });
  },

  [t.PRESETS]: (state, presets) => {
    state.presets = presets;
  },

  [t.RESULTS]: (state, { events }) => {
    state.events = events;
    state.hasSearched = true;
  },

  [t.SORT]: (state, sort) => {
    state.currentSort = sort;
  },

  [t.DATE_FILTER]: (state, date) => {
    state.dateFilter = date;
  },

  [t.STATUS]: (state, status) => {
    state.status = status;
  },

  [t.TOTAL_COUNT]: (state, [count, dayRange]) => {
    state.count = count;
    state.dayRange = dayRange;
  },

  [t.FIELD]: (state, [filter, metric, value, range]) => {
    state.currentPreset = '';

    Vue.set(state.metrics, metric, {
      ...state.metrics[metric],
      value,
      range,
    });

    Vue.set(state.fields, filter, {
      ...state.fields[filter],
      metric,
    });
  },
};
